export default __webpack_public_path__ + "static/media/c005-whatsapp-03.648f19aa.png";